import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Table,
  Form,
  Col,
  Row,
  Container,
} from "react-bootstrap";
import { FaCalendarAlt } from "react-icons/fa";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import {
  handleGetTenantData,
  handleGetTenantCropsData,
} from "../store/actions/tenantsActions";
import {
  handleGetCropList,
  handleCreateCrop,
  handleUpdateCrop,
  handleDeleteCrop,
} from "../store/actions/cropActions";
import Loader from "../assets/images/loader.gif";
import { ICONS, IMAGES } from "../constants/constants";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";


const ManageCrops = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortField, setSortField] = useState("sowingStartDate");
  const [sortOrder, setSortOrder] = useState("asc");
  const [isSavingCrop, setIsSavingCrop] = useState(false);
  const [isDeletingCrop, setIsDeletingCrop] = useState(false);
  const [imageBustMap, setImageBustMap] = useState({});


  const { tenantCropsData, isLoading } = useSelector(
    (state) => state.tenants
  );
  const { user } = useSelector((state) => state.user);

  const tenantId = user?.role === "superadmin" ? user?.tenant?.id : null;
  const cropsList = tenantCropsData?.data?.crops;
  // console.log("cropsList:", cropsList);
  const [showCropModal, setShowCropModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedCropId, setSelectedCropId] = useState(null);

  const [showCropDeleteModal, setShowCropDeleteModal] = useState(false);
  const [cropToDelete, setCropToDelete] = useState(null);



  const [cropData, setCropData] = useState({
    cropName: "",
    url: null,
    tenantId: tenantId,
    sowingStartDate: null,
    sowingEndDate: null,
    harvestingStartDate: null,
    harvestingEndDate: null,
    crop_image: null, // ✅ add this
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (tenantId) {
      dispatch(handleGetTenantData(tenantId));
      dispatch(handleGetTenantCropsData(tenantId));
    }
  }, [dispatch, tenantId]);

  useEffect(() => {
    const fetchCrops = async () => {
      await handleGetCropList(dispatch);
    };
    fetchCrops();
  }, [dispatch]);

  useEffect(() => {
    if (cropData.url instanceof File) {
      const previewUrl = URL.createObjectURL(cropData.url);
      return () => URL.revokeObjectURL(previewUrl);
    }
  }, [cropData.url]);

  const formatDate = (date) => {
    if (!date) return "";
    return date
      .toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
      })
      .replace(/\//g, "-");
  };

  const validateForm = () => {
    const newErrors = {};
    if (!cropData.cropName) newErrors.cropName = "Crop name is required";
    if (!cropData.sowingStartDate)
      newErrors.sowingStartDate = "Sowing start date is required";
    if (!cropData.sowingEndDate)
      newErrors.sowingEndDate = "Sowing end date is required";
    if (!cropData.harvestingStartDate)
      newErrors.harvestingStartDate = "Harvesting start date is required";
    if (!cropData.harvestingEndDate)
      newErrors.harvestingEndDate = "Harvesting end date is required";

    if (!editMode && !cropData.url)
      newErrors.url = "Image file is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const saveCrop = async () => {
    if (!validateForm()) return;
    if (isSavingCrop) return;
    setIsSavingCrop(true);

    const formData = new FormData();
    formData.append("cropName", cropData.cropName);
    if (!editMode && cropData.tenantId) {
      formData.append("tenantId", cropData.tenantId); // Only for create
    }
    // formData.append("sowingStartDate", formatDate(cropData.sowingStartDate));
    //   const formatDate = (date) => {
    //   if (!date) return "";
    //   const month = String(date.getMonth() + 1).padStart(2, "0");
    //   const day = String(date.getDate()).padStart(2, "0");
    //   return `${month}-${day}`; // ✅ always MM-DD, no year
    // };
    formData.append("sowingStartDate", formatDate(cropData.sowingStartDate));
    formData.append("sowingEndDate", formatDate(cropData.sowingEndDate));
    formData.append("harvestingStartDate", formatDate(cropData.harvestingStartDate));
    formData.append("harvestingEndDate", formatDate(cropData.harvestingEndDate));
   // saveCrop()
   if (cropData.url instanceof File) {
    formData.append("crop_image", cropData.url);
  } else {
    formData.append("crop_image", cropData.crop_image);
  }

    try {
      if (editMode && selectedCropId) {
        await handleUpdateCrop(selectedCropId, formData, dispatch);
        // If user uploaded a new file during edit, force-refresh the image URL once.
        if (cropData.url) {
          setImageBustMap((prev) => ({ ...prev, [selectedCropId]: Date.now() }));
        }
      } else {
        await handleCreateCrop(formData, dispatch);
              setCropData({
          cropName: "",
          url: null,
          tenantId: tenantId,
          sowingStartDate: null,
          sowingEndDate: null,
          harvestingStartDate: null,
          harvestingEndDate: null,
          crop_image: null, // ✅ add this
        });
      }
      setShowCropModal(false);
      setEditMode(false);
      setSelectedCropId(null);
      dispatch(handleGetTenantCropsData(tenantId)); // Refresh list
    } catch (error) {
      console.error("Error saving crop:", error);
    } finally {
      setIsSavingCrop(false);
    }
  };


  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/webp",
    ];
    if (!allowedTypes.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        url: "Only JPG, PNG, JPEG, WEBP allowed",
      }));
      return;
    }
    setCropData({ ...cropData, url: file });
    setErrors((prev) => ({ ...prev, url: "" }));
  };

  const openEditModal = (crop) => {
    setEditMode(true);
    setSelectedCropId(crop.id);
    console.log("Editing crop image URL:", crop.crop_image); // ✅ debug log
    setCropData({
      cropName: crop.crop_name,
      url: null, // ✅ ALWAYS null initially
      tenantId: crop.tenant_id,
      sowingStartDate: new Date(crop.sowingStartDate),
      sowingEndDate: new Date(crop.sowingEndDate),
      harvestingStartDate: new Date(crop.harvestingStartDate),
      harvestingEndDate: new Date(crop.harvestingEndDate),
      crop_image: crop.crop_image, // ✅ keep DB image
    });
    setShowCropModal(true);
  };


  const deleteCrop = (cropId) => {
    setCropToDelete(cropId);
    setShowCropDeleteModal(true);
  };


  const handleConfirmCropDelete = async () => {
    if (!cropToDelete) return;
    if (isDeletingCrop) return;
    setIsDeletingCrop(true);

    try {
      await handleDeleteCrop(cropToDelete, dispatch);
      dispatch(handleGetTenantCropsData(tenantId)); // Refresh list
    } catch (err) {
      console.error("Delete error:", err);
    } finally {
      setIsDeletingCrop(false);
      setShowCropDeleteModal(false);
      setCropToDelete(null);
    }
  };


  const closeModal = () => {
    setShowCropModal(false);
    setEditMode(false);
    setSelectedCropId(null);
    setCropData({
      cropName: "",
      url: null,
      tenantId: tenantId,
      sowingStartDate: null,
      sowingEndDate: null,
      harvestingStartDate: null,
      harvestingEndDate: null,
      crop_image: null, // ✅ add this
    });
    setErrors({});
  };

  const handleSort = (field) => {
    if (sortField === field) {
      // toggle sort order
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      // switch to new column
      setSortField(field);
      setSortOrder("asc");
    }
  };


  const filteredAndSortedCrops = cropsList
    ?.filter((crop) =>
      crop.crop_name?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    ?.sort((a, b) => {
      const dateA = new Date(a[sortField]);
      const dateB = new Date(b[sortField]);
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });



  const renderCropList = () => {
    if (!cropsList?.length) {
      return (
        <tr>
          <td colSpan="7">No crops added yet.</td>
        </tr>
      );
    }

    return filteredAndSortedCrops.map((crop) => (
      <tr key={crop.id}>
        <td>{crop.crop_name}</td>
        <td>{crop.sowingStartDate}</td>
        <td>{crop.sowingEndDate}</td>
        <td>{crop.harvestingStartDate}</td>
        <td>{crop.harvestingEndDate}</td>
        <td>
          <img
            src={
              imageBustMap?.[crop.id]
                ? `${crop.crop_image}${crop.crop_image?.includes("?") ? "&" : "?"}v=${imageBustMap[crop.id]}`
                : crop.crop_image
            }
            alt={crop.crop_name || "Crop Image"}
            style={{ width: 25, height: 25, objectFit: "cover" }}
            onError={(e) => { e.target.src = IMAGES.productImage; }}
          />
        </td>
        <td>
          <Button
            variant="link"
            className="p-0 border-0 bg-transparent"
            onClick={() => openEditModal(crop)}

          >
            <img src={ICONS.editIcon} className="faPlusIcon" alt="delete" />
          </Button>
          <Button
            variant="link"
            className="p-0 border-0 bg-transparent"
            onClick={() => deleteCrop(crop.id)}
          >
            <img src={ICONS.deleteIcon} className="faPlusIcon" alt="delete" />
          </Button>
        </td>

      </tr>
    ));
  };

  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }

  return (
    <Container>

      <Modal show={showCropDeleteModal} onHide={() => setShowCropDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this crop?
        </Modal.Body>
        <Modal.Footer>
          <Button className="reject-button" onClick={() => setShowCropDeleteModal(false)} disabled={isDeletingCrop}>
            Cancel
          </Button>
          <Button className="button" onClick={handleConfirmCropDelete} disabled={isDeletingCrop}>
            {isDeletingCrop ? "Deleting..." : "Yes"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Row className="component-container mb-2">
        <Col md={12}>
          <Row className="align-items-center mb-3">
            <Col md={4}>
              <h4>Crops</h4>
            </Col>
            <Col md={4}>
              <Form.Control
                type="text"
                placeholder="Search crop..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Col>
            <Col md={4} className="text-end">


              <Button className="button" onClick={() => setShowCropModal(true)}>
                <img src={ICONS.addPlusIcon} className="faPlusIcon" alt="Add" /> Add New Crop
              </Button>
            </Col>
          </Row>



          <div className="table-responsive">
            <Table striped bordered hover responsive className="mt-3">
              <thead>
                <tr>
                  <th>Crop</th>

                  <th onClick={() => handleSort("sowingStartDate")} style={{ cursor: "pointer" }}>
                    Sowing Start{" "}
                    {sortField === "sowingStartDate" ? (
                      sortOrder === "asc" ? <FaSortUp /> : <FaSortDown />
                    ) : (
                      <FaSort />
                    )}
                  </th>

                  <th onClick={() => handleSort("sowingEndDate")} style={{ cursor: "pointer" }}>
                    Sowing End{" "}
                    {sortField === "sowingEndDate" ? (
                      sortOrder === "asc" ? <FaSortUp /> : <FaSortDown />
                    ) : (
                      <FaSort />
                    )}
                  </th>

                  <th onClick={() => handleSort("harvestingStartDate")} style={{ cursor: "pointer" }}>
                    Harvesting Start{" "}
                    {sortField === "harvestingStartDate" ? (
                      sortOrder === "asc" ? <FaSortUp /> : <FaSortDown />
                    ) : (
                      <FaSort />
                    )}
                  </th>

                  <th onClick={() => handleSort("harvestingEndDate")} style={{ cursor: "pointer" }}>
                    Harvesting End{" "}
                    {sortField === "harvestingEndDate" ? (
                      sortOrder === "asc" ? <FaSortUp /> : <FaSortDown />
                    ) : (
                      <FaSort />
                    )}
                  </th>

                  <th>Image</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>{renderCropList()}</tbody>
            </Table>
          </div>
        </Col>
      </Row>
      <Modal show={showCropModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Modal.Title>
              {editMode ? "Edit Crop" : "Add New Crop"}
            </Modal.Title>
            <small style={{ fontSize: "14px", color: "#6c757d" }}>
              {editMode
                ? "Update the crop details below"
                : "Enter details for crop"}
            </small>
          </div>
        </Modal.Header>

        <Modal.Body>
          <Form.Group>
            <Form.Label>Crop Name<span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control
              type="text"
              name="cropName"
              value={cropData.cropName}
              onChange={(e) => {
                setCropData({ ...cropData, cropName: e.target.value });
                if (errors.cropName) {
                  setErrors({ ...errors, cropName: "" }); // ✅ clear error instantly
                }
              }}
              isInvalid={!!errors.cropName}
            />
            <Form.Control.Feedback type="invalid">
              {errors.cropName}
            </Form.Control.Feedback>
          </Form.Group>



          <Row>
            {[
              { key: "sowingStartDate", label: "Sowing Start Date" },
              { key: "sowingEndDate", label: "Sowing End Date" },
              { key: "harvestingStartDate", label: "Harvesting Start Date" },
              { key: "harvestingEndDate", label: "Harvesting End Date" },
            ].map(({ key, label }) => (
              <Col md={6} key={key}>


                <Form.Group className="form-input">
                  <Form.Label>{label}<span style={{ color: 'red' }}>*</span></Form.Label>



                  <div className="crop-date-picker-container position-relative">
                  

<DatePicker
  selected={cropData[key]}
  onChange={(date) => {
    setCropData({ ...cropData, [key]: date });
    if (errors[key]) {
      setErrors({ ...errors, [key]: "" });
    }
  }}
  dateFormat="MM-dd-yyyy"
  placeholderText="MM-DD-YYYY"
  className={`form-control ${errors[key] ? "is-invalid" : ""}`}

  // ❌ remove dropdowns
  // showMonthDropdown
  // showYearDropdown

  // ✅ custom header for arrows
  renderCustomHeader={({
    date,
    decreaseMonth,
    increaseMonth,
    decreaseYear,
    increaseYear,
  }) => (
    <div className="d-flex justify-content-between align-items-center px-2">
      
      {/* Year arrows */}
      <button type="button" onClick={decreaseYear} className="btn btn-sm">
        <FaChevronLeft />
      </button>

      <span className="fw-bold">{date.getFullYear()}</span>

      <button type="button" onClick={increaseYear} className="btn btn-sm">
        <FaChevronRight />
      </button>

      {/* Month arrows */}
      <button type="button" onClick={decreaseMonth} className="btn btn-sm ms-3">
        <FaChevronLeft />
      </button>

      <span className="fw-bold">
        {date.toLocaleString("default", { month: "long" })}
      </span>

      <button type="button" onClick={increaseMonth} className="btn btn-sm">
        <FaChevronRight />
      </button>
    </div>
  )}
/>

                    <img src={ICONS.calenderIcon} className="calendar-icon" style={{ display: errors[key] ? "none" : "block" }} alt="Calendar" />



                    {/* <FaCalendarAlt className="calendar-icon" /> */}
                    {/* <img src={ICONS.calenderIcon} className="calendar-icon" alt="Calender" />
                    <Form.Control.Feedback className="d-block" type="invalid">
                      {errors[key]}
                    </Form.Control.Feedback> */}
                  </div>
                  <Form.Control.Feedback type="invalid" style={{ display: errors[key] ? "block" : "none" }}>
                    {errors[key]}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            ))}
          </Row>

          {/* <Form.Group className="form-input">
  <Form.Label>Upload Image</Form.Label>
< br/>
 
  <Form.Control
    type="file"
    onChange={handleImageUpload}
    isInvalid={!!errors.url}
    id="customFileInput"
    style={{ display: "none" }}
  />

  
  <label
    htmlFor="customFileInput"
    className="custom-upload-btn"
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "12px",
      background: "transparent",
      color: "#fff",
      padding: "12px 22px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      cursor: "pointer",
      minWidth: "100px",  // ensures bigger box
    minHeight: "50px"  // ensures taller box
    }}
  >
   <img src={ICONS.colorAddPlusIcon}  style={{
      width: "50px",  // bigger icon size
      height: "25px"
    }}  alt="Calender" />
  </label>


  <Form.Control.Feedback type="invalid" style={{ display: errors.url ? "block" : "none" }}>
    {errors.url}
  </Form.Control.Feedback>
</Form.Group> */}

          <Form.Group className="form-input">
            <Form.Label>Upload Image<span style={{ color: 'red' }}>*</span></Form.Label>
            <br />

            {/* Hidden File Input */}
            <Form.Control
              type="file"
              onChange={handleImageUpload}
              isInvalid={!!errors.url}
              id="customFileInput"
              style={{ display: "none" }}
            />

            {/* Show image in edit mode, otherwise show plus icon */}
            <label
              htmlFor="customFileInput"
              className="custom-upload-btn"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "12px",
                background: "transparent",
                color: "#fff",
                padding: "12px 22px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                cursor: "pointer",
                minWidth: "100px",
                minHeight: "50px",
              }}
            >
              {/* {editMode && !cropData.url ? (

                // show DB image
                <img
                  src={cropData.crop_image}
                  alt="Crop"
                  style={{ width: "80px", height: "50px", objectFit: "cover", borderRadius: "4px" }}
                  onError={(e) => { e.target.src = IMAGES.productImage; }}
                />
              ) : cropData.url ? (
                // show preview if user selected new file
                <img
                  src={URL.createObjectURL(cropData.url)}
                  alt="Preview"
                  style={{ width: "80px", height: "50px", objectFit: "cover", borderRadius: "4px" }}
                />
              ) : (
                // default plus icon
                <img
                  src={ICONS.colorAddPlusIcon}
                  style={{ width: "50px", height: "25px" }}
                  alt="Upload"
                />
              )} */}

{editMode && !cropData.url ? (
  // show DB image
  <img
    src={cropData.crop_image}
    alt="Crop"
    style={{ width: "80px", height: "50px", objectFit: "cover" }}
    onError={(e) => (e.target.src = IMAGES.productImage)}
  />
) : cropData.url instanceof File ? (
  // show preview of uploaded file
  <img
    src={URL.createObjectURL(cropData.url)}
    alt="Preview"
    style={{ width: "80px", height: "50px", objectFit: "cover" }}
  />
) : (
  // plus icon
  <img
    src={ICONS.colorAddPlusIcon}
    style={{ width: "50px", height: "25px" }}
    alt="Upload"
  />
)}

            </label>

            {/* Error Message */}
            <Form.Control.Feedback
              type="invalid"
              style={{ display: errors.url ? "block" : "none" }}
            >
              {errors.url}
            </Form.Control.Feedback>
          </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          <Button className="button" onClick={saveCrop} disabled={isSavingCrop}>
            {isSavingCrop ? "Saving..." : editMode ? "Update Crop" : "Add Crop"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ManageCrops;
